import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const CheckIcon = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props), /* @__PURE__ */ React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(-496.000000, 0.000000)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement(
  "polyline",
  {
    stroke: "#FFFFFF",
    strokeWidth: "2",
    points: "508 23.8193359 508 64 0 64 0 12 496.790039 12"
  }
), /* @__PURE__ */ React.createElement("g", { transform: "translate(496.000000, 0.000000)" }, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("circle", { fill: "#FFFFFF", cx: "12", cy: "12", r: "12" }), /* @__PURE__ */ React.createElement("g", { transform: "translate(5.000000, 8.000000)", fill: "currentColor" }, /* @__PURE__ */ React.createElement("polygon", { points: "12.2335029 0.239154296 13.4174702 1.3883133 5.59026761 9.73257326 0.586372643 5.73025155 1.59665912 4.42329121 5.43146554 7.49052765" }))), /* @__PURE__ */ React.createElement("g", { transform: "translate(5.000000, 8.000000)" }))))));

export { CheckIcon };
//# sourceMappingURL=CheckIcon.js.map
